import { gql } from '@apollo/client';

import { stimulusResourceFragment } from 'approot/shared/stimulus/stimulus.graphql';

export const lessonStimulusFragment = gql`
  fragment LessonStimulusFragment on Lesson {
    id
    stimulusResources {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;

export const GET_LESSON_BY_ID = gql`
  query GetStimulusLessonById($input: GetLessonByIdInput!) {
    getLessonById(input: $input) {
      id
      stimulusResources {
        ...StimulusResource
      }
    }
  }
  ${stimulusResourceFragment}
`;
